import { Component, OnInit, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { Model } from 'src/app/entities/model';
import { HeaderService } from 'src/app/tools/header.service';
import { BodyItem } from 'src/app/entities/BodyItem';
import { Shade } from 'src/app/entities/BodyItem';
import { Accessory } from 'src/app/entities/Accessory';
import { StorageService } from 'src/app/tools/storage.service';
import { Router, Event } from '@angular/router';
import { IxellAPIService, Accessoire, TeinteCarrosserie, TeinteCB } from 'src/app/tools/api.service';
import { ColorGroup } from '../../entities/ColorGroup';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Sort } from '@angular/material/sort';


@Component({
    selector: 'bodyShade',
    templateUrl: './bodyShade.component.html',
    styleUrls: ['./bodyShade.component.scss']
})

export class BodyShadeComponent implements OnInit {
    constructor(private headerService: HeaderService, private storage: StorageService, private router: Router, private apiService: IxellAPIService) { }

    @Input() model: Model;
    @Input() manufacturer: string;
    @Input() isRenaultDacia: Boolean;

    accessoriesFront: Accessory[] = [];
    accessoriesRear: Accessory[] = [];
    allAccessories: Accessory[] = [];
    allAccessoriesGlob: Accessory[] = [];

    bodyItems: BodyItem[];
    selectedBodyItem: BodyItem;
    selectedAccessory: BodyItem;
    selectedShade: Shade;
    colorList: ColorGroup[] = [];
    view: string = "AV";
    isOpend: boolean = false;
    img: string;
    haveBodyColor: boolean = false;
    yearList: string[] = [];
    isSortCode: boolean = true;
    isSortDesignation: boolean = false;
    asc: boolean = true;

    colorCode: string;
    categoryName: string;
    selectLignePeinture: boolean = false;
    technology: string = "ixell";

    private accessoriesSub: any;
    private autreMarqueSub: any;
    private autreMarqueCarrosSub: any;
    private colorCarrosserieSub: any;
    private colorSub: any;

    ShadeForm = new UntypedFormGroup({
        color: new UntypedFormControl(''),
        effect: new UntypedFormControl(''),
        year: new UntypedFormControl('')
    });

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    ngOnInit(): void {
        ///*----------------------------------------------------------------------------------------------------*/console.log("/*----------------------------------------------------------------------------------------------------*/");
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : ngOnInit");

        this.headerService.changeTitle(this.model.name);
        this.headerService.changeCanBack(true);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.model);

        let language = this.storage.get("actualLanguage");
        if (language == "" || language == null)
            language = "fr";

        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            history.go(1);
        };
        let mod = this.model.name;
        let man = this.manufacturer;
        if (this.manufacturer == "RENAULT" || this.manufacturer == "DACIA" || this.manufacturer == "ALPINE") {

            mod = this.model.gamme != null ? this.model.gamme : this.model.name;
            if (this.manufacturer == "ALPINE") {
                man = "RENAULT";
                mod = "ALPINE";
            }
        }

        this.accessoriesSub = this.apiService.getAccessoriesColorBook(this.model.id, man, mod).subscribe(data => {

            ///*----------------------------------------------------------------------------------------------------*/console.log("getAccessoriesColorBook");
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);

            let accessoires: Accessoire[] = data;
            accessoires.forEach(element => {
                this.addAccessory(element.designation, element.accessoire_id, element.teintes, element.front)
            });
            if (this.manufacturer == "RENAULT" || this.manufacturer == "DACIA" || this.manufacturer == "ALPINE")
                this.img = "assets/" + this.manufacturer + "/" + this.model.name + ".png";
            else
                this.img = "assets/generique-couleur.png";

            //récupération des groupes de couleur de teinte disponibles
            this.colorSub = this.apiService.getColorGroup(language).subscribe(data => {
                this.colorList = data;
                if (this.colorSub != null) this.colorSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.colorSub != null) this.colorSub.unsubscribe();
                });

            if (this.accessoriesSub != null) this.accessoriesSub.unsubscribe();
        }, error => {
            if (this.accessoriesSub != null) this.accessoriesSub.unsubscribe();
            console.log(error);
        });

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    noBack() {
        this.headerService.changeBack(true);
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    addAccessory(designation: string, accessoire_id: string, teintes: TeinteCB[], front: boolean) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : addAccessory");
        ///*----------------------------------------------------------------------------------------------------*/console.log("teintesCB", teintes);

        let accessory: Accessory = new Accessory();
        let accessory2: Accessory = new Accessory();
        let shades: Shade[] = [];
        let shades2: Shade[] = [];

        accessory.name = "accessories." + designation;
        accessory.open = false;
        accessory.className = "accessoire";
        accessory.id = accessoire_id
        accessory.type = designation.replace(/\s/g, "");
        accessory2 = Object.assign({}, accessory);

        teintes.forEach(element => {
            let sha: Shade = new Shade();
            sha.colorCode = element.code_couleur;
            sha.colorName = element.libelle;
            sha.rvb = element.couleur;
            sha.aerosol = element.aerosol;
            sha.effects = element.effects;
            sha.grpcoul = element.grpCoul;
            sha.dateFrom = element.dateFrom;
            sha.dateTo = element.dateTo;
            sha.dateOfUse = (element.dateOfUse) ? element.dateOfUse : "";
            shades.push(sha);
            shades2.push(sha);
        });

        ///*----------------------------------------------------------------------------------------------------*/console.log("shades", shades);

        accessory.shades = shades;
        accessory2.shades = shades2;
        if (shades.length > 0) {
            accessory.visibility = "visible";
            accessory2.visibility = "visible";
        }
        else {
            accessory.visibility = "hidden";
            accessory2.visibility = "hidden";
        }

        if (accessoire_id != "-1") {
            if (front)
                this.accessoriesFront.push(accessory);
            else
                this.accessoriesRear.push(accessory);
        }
        else {
            var allUnique = [];
            this.yearList.push("");
            accessory.shades.forEach(s => {

                ///*----------------------------------------------------------------------------------------------------*/console.log(s);

                allUnique = [...allUnique, ...s.dateOfUse.split(", ").filter((item, i, ar) => ar.indexOf(item) === i)];
            });
            this.yearList = [...this.yearList, ...allUnique.filter((item, i, ar) => ar.indexOf(item) === i).sort((a, b) => a - b)];

            if (accessory.visibility == "visible")
                this.haveBodyColor = true;
        }

        this.allAccessories.push(accessory);
        this.allAccessoriesGlob.push(accessory2);
        let data = this.allAccessories;
        this.allAccessories = data.sort((a, b) => {
            if (a.id == "-1") return -1;
            else if (b.id == "-1") return 1;
            else if (a.type < b.type) return -1;
            else return 1;
        }).slice();
    }


    async selectLignePeintureColorWebTech(color: Shade, categoryName: string) {

        ///*----------------------------------------------------------------------------------------------------*/console.log("selectLignePeintureColorWebTech");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.technology);
        this.colorCode = color.colorCode.trim();
        this.categoryName = categoryName;

        if (this.technology == "ixell" || this.technology == "oxelia") {
            
            this.launchColorWebTech("colorwebtech", "ColorWebtech");
        } else {
            this.launchColorWebTech("equinox", "Equinox");
        } 
    }

    //async selectLignePeintureColorWebTech() {

    //    //console.log(this.technology);

    //    //this.selectLignePeinture = false;
    //    //this.launchColorWebTech();
    //}

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    async launchColorWebTech(route: string, titre: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : launchColorWebTech");
        await this.apiService.statsLogCBCategorie(this.categoryName).toPromise().catch();

        this.headerService.changeTitle(titre);
        this.storage.set("manufacturer", this.manufacturer);
        this.storage.set("colorCode", this.colorCode);
        this.storage.set("technology", this.technology);
        this.storage.set("previous", "colorbook");
        this.router.navigate(["/" + route]);
    }

    ///* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    ///**
    // * 
    // */
    //async launchColorWebTechColorModel(color: TeinteCarrosserie, categoryName: string) {
    //    ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : launchColorWebTechColorModel");
    //    await this.apiService.statsLogCBCategorie(categoryName).toPromise().catch();

    //    this.headerService.changeTitle("ColorWebtech");
    //    this.storage.set("manufacturer", this.manufacturer);
    //    this.storage.set("colorCode", color.code.trim());
    //    this.storage.set("technology", "ixell");
    //    this.storage.set("previous", "colorbook");
    //    this.router.navigate(["/colorwebtech"]);
    //}

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    Revers() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : Revers");
        if (this.view == "AV") {
            this.view = "AR";
            document.getElementById("AV").classList.remove("phoneViewVeh");
            document.getElementById("AR").classList.add("phoneViewVeh");
        }
        else {
            this.view = "AV";
            document.getElementById("AV").classList.add("phoneViewVeh");
            document.getElementById("AR").classList.remove("phoneViewVeh");
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    sortCode(shades: Shade[]) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : sortCode");
        if (this.isSortCode)
            this.asc = !this.asc;
        else
            this.asc = true;

        this.isSortDesignation = false;
        this.isSortCode = true;
        if (this.asc) {
            shades.sort(function (a, b) {
                if (a.colorCode == b.colorCode) return 0;
                else if (a.colorCode > b.colorCode) return 1;
                else if (a.colorCode < b.colorCode) return -1;
            });
        }
        else {
            shades.sort(function (a, b) {
                if (a.colorCode == b.colorCode) return 0;
                else if (a.colorCode > b.colorCode) return -1;
                else if (a.colorCode < b.colorCode) return 1;
            });
        }
        this.allAccessories.find(a => a.open == true).shades = shades;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    sortDesignation(shades: Shade[]) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : sortDesignation");
        if (this.isSortDesignation)
            this.asc = !this.asc;
        else
            this.asc = true;
        this.isSortDesignation = true;
        this.isSortCode = false;
        if (this.asc) {
            shades.sort(function (a, b) {
                if (a.colorCode == b.colorCode) return 0;
                else if (a.colorName > b.colorName) return 1;
                else if (a.colorName < b.colorName) return -1;
            });
        }
        else {
            shades.sort(function (a, b) {
                if (a.colorName == b.colorName) return 0;
                else if (a.colorName > b.colorName) return -1;
                else if (a.colorName < b.colorName) return 1;
            });
        }
        this.allAccessories.find(a => a.open == true).shades = shades;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    openaccordion(type: string, event: any, element: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : openaccordion");
        this.asc = false;
        this.isSortDesignation = false;
        this.isSortCode = true;
        this.accessoriesFront.forEach(af => af.className == "accessoire");
        this.accessoriesRear.forEach(ar => ar.className == "accessoire");
        for (var _i = 0; _i < document.getElementsByClassName("accessoireActif").length; _i++) {
            document.getElementsByClassName("accessoireActif")[_i].className = "accessoire";
        }
        if (event != null) {
            if (event.currentTarget.className.indexOf("accessoire") > 0)
                event.currentTarget.className = "accessoireActif";
        }
        else {
            if (document.getElementById(type) != null)
                document.getElementById(type).className = "accessoireActif";
        }

        const accordionElem = (document.getElementsByClassName(type)[0] as HTMLElement);

        if (element == "button") {
            var children = document.getElementById("shadeAccordion").children;
            for (var i = 0; i < document.getElementById("shadeAccordion").children.length; i++) {
                if ((children[i] as HTMLElement).style.order == "-1")
                    (children[i] as HTMLElement).style.order = "0";
            }
            accordionElem.style.order = "-1";
            accordionElem.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            document.getElementById("bodyItems").scrollTop = 0;
        }
        else {
            if (accordionElem.style.order != "-1")
                accordionElem.style.order = "0";
        }

        this.allAccessories.forEach(element => {
            if (element.type != type) {
                element.open = false;
            }
            else {
                element.open = true;
                this.sortCode(element.shades);
            }
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    colorFilter() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : colorFilter");
        this.asc = true;
        this.isSortDesignation = false;
        this.isSortCode = true;

        let shad: Shade[] = [];
        shad = this.allAccessoriesGlob.find(a => a.id == "-1").shades.filter(s => {
            if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                if (s.grpcoul == this.ShadeForm.value.color)
                    if (this.ShadeForm.value.effect != "" && this.ShadeForm.value.effect != "0") {
                        if (this.ShadeForm.value.effect != "E" && !s.effects.includes("M") && !s.effects.includes("P")) {
                            if (s.effects.includes(this.ShadeForm.value.effect))
                                if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                    if (s.grpcoul == this.ShadeForm.value.color)
                                        if (this.ShadeForm.value.year != "") {
                                            //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                            if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                                return s
                                        }
                                        else
                                            return s;
                                }
                                else
                                    if (this.ShadeForm.value.year != "") {
                                        //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                        if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                            return s
                                    }
                                    else
                                        return s;
                        }
                        else {
                            if (this.ShadeForm.value.effect == "E" && (s.effects.includes("M") || s.effects.includes("P")))
                                if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                    if (s.grpcoul == this.ShadeForm.value.color)
                                        if (this.ShadeForm.value.year != "") {
                                            //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                            if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                                return s
                                        }
                                        else
                                            return s;
                                }
                                else
                                    if (this.ShadeForm.value.year != "") {
                                        //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                        if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                            return s
                                    }
                                    else
                                        return s;
                        }
                    }
                    else {
                        if (this.ShadeForm.value.year != "") {
                            //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                            if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                return s
                        }
                        else
                            return s;
                    }
            }
            else {
                if (this.ShadeForm.value.effect != "" && this.ShadeForm.value.effect != "0") {
                    if (this.ShadeForm.value.effect != "E" && !s.effects.includes("M") && !s.effects.includes("P")) {
                        if (s.effects.includes(this.ShadeForm.value.effect))
                            if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                if (s.grpcoul == this.ShadeForm.value.color)
                                    if (this.ShadeForm.value.year != "") {
                                        //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                        if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                            return s
                                    }
                                    else
                                        return s;
                            }
                            else
                                if (this.ShadeForm.value.year != "") {
                                    //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                    if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                        return s
                                }
                                else
                                    return s;
                    }
                    else {
                        if (this.ShadeForm.value.effect == "E" && (s.effects.includes("M") || s.effects.includes("P")))
                            if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                if (s.grpcoul == this.ShadeForm.value.color)
                                    if (this.ShadeForm.value.year != "") {
                                        //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                        if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                            return s
                                    }
                                    else
                                        return s;
                            }
                            else
                                if (this.ShadeForm.value.year != "") {
                                    //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                    if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                        return s
                                }
                                else
                                    return s;
                    }
                }
                else
                    if (this.ShadeForm.value.year != "") {
                        //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                        if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                            return s
                    }
                    else
                        return s;
            }
        });
        this.allAccessories.find(a => a.id == "-1").shades = shad;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    effectFilter() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : effectFilter");
        this.asc = true;
        this.isSortDesignation = false;
        this.isSortCode = true;

        let shad: Shade[] = [];
        shad = this.allAccessoriesGlob.find(a => a.id == "-1").shades.filter(s => {
            if (this.ShadeForm.value.effect != "" && this.ShadeForm.value.effect != "0") {
                if (this.ShadeForm.value.effect != "E" && !s.effects.includes("M") && !s.effects.includes("P")) {
                    if (s.effects.includes(this.ShadeForm.value.effect))
                        if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                            if (s.grpcoul == this.ShadeForm.value.color)
                                if (this.ShadeForm.value.year != "") {
                                    //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                    if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                        return s
                                }
                                else
                                    return s;
                        }
                        else
                            if (this.ShadeForm.value.year != "") {
                                //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                    return s
                            }
                            else
                                return s;
                }
                else {
                    if (this.ShadeForm.value.effect == "E" && (s.effects.includes("M") || s.effects.includes("P")))
                        if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                            if (s.grpcoul == this.ShadeForm.value.color)
                                if (this.ShadeForm.value.year != "") {
                                    //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                    if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                        return s
                                }
                                else
                                    return s;
                        }
                        else
                            if (this.ShadeForm.value.year != "") {
                                //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                                if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                    return s
                            }
                            else
                                return s;
                }
            }
            else {
                if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                    if (s.grpcoul == this.ShadeForm.value.color)
                        if (this.ShadeForm.value.year != "") {
                            //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                            if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                                return s
                        }
                        else
                            return s;
                }
                else
                    if (this.ShadeForm.value.year != "") {
                        //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year)
                        if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1)
                            return s
                    }
                    else
                        return s;
            }
        });
        this.allAccessories.find(a => a.id == "-1").shades = shad;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    yearFilter() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : yearFilter");
        this.asc = true;
        this.isSortDesignation = false;
        this.isSortCode = true;

        let shad: Shade[] = [];
        shad = this.allAccessoriesGlob.find(a => a.id == "-1").shades.filter(s => {
            if (this.ShadeForm.value.year != "") {
                //if (s.dateFrom <= this.ShadeForm.value.year && s.dateTo >= this.ShadeForm.value.year) {
                if (s.dateOfUse.split(", ").indexOf(this.ShadeForm.value.year) > -1) {
                    if (this.ShadeForm.value.effect != "" && this.ShadeForm.value.effect != "0") {
                        if (this.ShadeForm.value.effect != "E" && !s.effects.includes("M") && !s.effects.includes("P")) {
                            if (s.effects.includes(this.ShadeForm.value.effect))
                                if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                    if (s.grpcoul == this.ShadeForm.value.color)
                                        return s;
                                }
                                else
                                    return s;
                        }
                        else {
                            if (this.ShadeForm.value.effect == "E" && (s.effects.includes("M") || s.effects.includes("P")))
                                if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                    if (s.grpcoul == this.ShadeForm.value.color)
                                        return s;
                                }
                                else
                                    return s;
                        }
                    }
                    else {
                        if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                            if (s.grpcoul == this.ShadeForm.value.color)
                                return s;
                        }
                        else
                            return s;
                    }
                }
            }
            else {
                if (this.ShadeForm.value.effect != "" && this.ShadeForm.value.effect != "0") {
                    if (this.ShadeForm.value.effect != "E" && !s.effects.includes("M") && !s.effects.includes("P")) {
                        if (s.effects.includes(this.ShadeForm.value.effect))
                            if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                if (s.grpcoul == this.ShadeForm.value.color)
                                    return s;
                            }
                            else
                                return s;
                    }
                    else {
                        if (this.ShadeForm.value.effect == "E" && (s.effects.includes("M") || s.effects.includes("P")))
                            if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                                if (s.grpcoul == this.ShadeForm.value.color)
                                    return s;
                            }
                            else
                                return s;
                    }
                }
                else {
                    if (this.ShadeForm.value.color != "0" && this.ShadeForm.value.color != "") {
                        if (s.grpcoul == this.ShadeForm.value.color)
                            return s;
                    }
                    else
                        return s;
                }
            }
        });
        this.allAccessories.find(a => a.id == "-1").shades = shad;
    }

    yearsToPeriod(dateOfUse: string) {
        /*
        
          if(!string.IsNullOrEmpty(teinte.DateOfUse))
          {
              List<string> r = new List<string>();
              int[] years = teinte.DateOfUse.Split(';').Select(year => int.Parse(year)).ToArray();
    
              int currentBeginning = years[0];
              int currentYear = years[0];
    
              for(int yI = 1; yI < years.Length; yI++)
              {
                  int year = years[yI];
                  if(year != currentYear + 1)
                  {
                      r.Add((currentBeginning != currentYear) ? $"{currentBeginning} - {currentYear}" : currentBeginning.ToString());
                      currentBeginning = year;
                  }
    
                  currentYear = year;
              }
    
              r.Add((currentBeginning != currentYear) ? $"{currentBeginning} - {currentYear}" : currentBeginning.ToString());
    
              teinte.DateOfUse = string.Join(", ", r);
          }
        */

        if (dateOfUse === null || dateOfUse.length == 0)
            return dateOfUse;

        const r: string[] = [];
        const years: number[] = dateOfUse.split(', ').map(year => Number(year));

        let currentBeginning = years[0];
        let currentYear = years[0];

        for (let yI = 1; yI < years.length; yI++) {
            let year = years[yI];
            if (year != currentYear + 1) {
                r.push((currentBeginning != currentYear) ? `${currentBeginning} - ${currentYear}` : currentBeginning.toString());
                currentBeginning = year;
            }

            currentYear = year;
        }

        r.push((currentBeginning != currentYear) ? `${currentBeginning} - ${currentYear}` : currentBeginning.toString());

        return r.join(', ');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    ngOnDestroy(): void {
        ///*----------------------------------------------------------------------------------------------------*/console.log("bodyShade : ngOnDestroy");
        if (this.accessoriesSub != null) this.accessoriesSub.unsubscribe();
        if (this.colorCarrosserieSub != null) this.colorCarrosserieSub.unsubscribe();
        if (this.autreMarqueSub != null) this.autreMarqueSub.unsubscribe();
        if (this.autreMarqueCarrosSub != null) this.autreMarqueCarrosSub.unsubscribe();
    }
}
